<template>
    <div class="process-box">
        <div class="process_left">
            <div class="process_left_long_img" v-if="type == 'long'">
                <img src="../../assets/images/long_process.png">
            </div>
            <div class="process_left_short_img" v-else>
                <img src="../../assets/images/short_process.png">
            </div>
        </div>
        <div class="show" v-if="type == 'long'">
            <div class="process_right" v-for="(item, index) in processConfig">
                <div class="process_right_top" >
                    <div class="process_right_top_img">
                        <img src="../../assets/images/ellipse.png" alt="">
                    </div>
                    <div class="process_right_top_text">
                        {{ item.processRightTopText }}
                    </div>
                </div>
                <div class="process_right_bottom" :ref="'process_right_bottom_' + index" v-html="item.processRightBottom">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "process",
    data() {
        return {

        }
    },

    props: {
        type: {
            type: String,
            default: "short"
        },
        processConfig: {
            type: Array,
            default: () => []
        }
    },

    watch: {},

    components: {},

    computed: {},

    created() {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.process-box {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;

    .process_left {
        width: 105px;
        margin-right: 90px;

        .process_left_long_img {
            width: 22px;
            height: 376px;
            margin: auto;

            >img {
                height: 100%;
                width: 100%;
            }
        }

        .process_left_short_img {
            width: 22px;
            height: 57px;
            margin: auto;

            >img {
                height: 100%;
                width: 100%;
            }
        }
    }
    .show{
        flex: 1;
    }
    .process_right {
        width: 100%;
        margin-bottom: 30px;
        .process_right_top {
            background-color: rgba(5,162,225,0.04);
            height: 60px;
            width: 100%;
            padding-left: 20px;
            margin-bottom: 16px;
            box-sizing: border-box;
            text-align: left;
            display: flex;
            align-items: center;

            .process_right_top_img {
                height: 20px;
                width: 20px;
                margin-right: 10px;
                >img {
                    height: 100%;
                    width: 100%;
                }
            }

            .process_right_top_text {
                font-size: 20px;
                font-weight: bold;
                color: #222222;
                line-height: 26px;
            }
        }

        .process_right_bottom {
            font-size: 16px;
            color: #666666;
            line-height: 31px;
            text-align: left;
            text-indent: 2em;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/step/process.vue